import { OnboardingStep } from '@mnd-frontend/graphql-schema';
import { Icons } from '@mnd-frontend/ui/publish/components';
import type { NavigateFunction } from 'react-router';
import routes from '../../../../../routes';

export const getStepIcon = (step: string) => {
  switch (step) {
    case OnboardingStep.Account:
      return <Icons.CircleUser />;
    case OnboardingStep.Pressrelease:
      return <Icons.CirclePlus />;
    case OnboardingStep.Contacts:
      return <Icons.User />;
    case OnboardingStep.Preview:
      return <Icons.Web />;
    case OnboardingStep.Newsroom:
      return <Icons.Visibility />;
    case OnboardingStep.PublishPressrelease:
      return <Icons.TextFile />;
    case OnboardingStep.Analyze:
      return <Icons.Analyze />;
    case OnboardingStep.VideoCourses:
      return <Icons.LearningVideo />;
    default:
      return <Icons.Sliders />;
  }
};

export const getStepAction = ({
  step,
  pressroomId,
  completeStepMutation,
  navigate,
}: {
  step: string;
  pressroomId: string;
  completeStepMutation: (input: any) => void;
  navigate: NavigateFunction;
}) => {
  switch (step) {
    case OnboardingStep.Pressrelease:
    case OnboardingStep.PublishPressrelease:
      return () =>
        navigate(
          routes.publishList({
            pressroomId,
            materialType: 'pressreleases',
          }),
        );
    case OnboardingStep.Contacts:
      return () => navigate(routes.contacts({ pressroomId }));
    case OnboardingStep.Preview:
      return () => {
        completeStepMutation({ variables: { pressroomId, step: OnboardingStep.Preview } });
        navigate(
          routes.preview({
            pressroomId,
          }),
        );
      };
    case OnboardingStep.Newsroom:
      return () =>
        navigate(
          `${routes.dashboard({
            pressroomId,
          })}?onboarding-step=branding`,
        );
    case OnboardingStep.Analyze:
      return () => {
        completeStepMutation({ variables: { pressroomId, step: OnboardingStep.Analyze } });
        navigate(
          routes.analyzeOverview({
            pressroomId,
          }),
        );
      };
    case OnboardingStep.VideoCourses:
      return () => {
        completeStepMutation({ variables: { pressroomId, step: OnboardingStep.VideoCourses } });
        navigate(
          `${routes.dashboard({
            pressroomId,
          })}?onboarding-course=open`,
        );
      };
    case OnboardingStep.Account:
    default:
      return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
  }
};
